export const libraryQueryKeys = {
	myCard: {
		all: ["myCard"] as const,
		byId: (cardId: string) => [...libraryQueryKeys.myCard.all, cardId] as const,
		ofId: (cardId: string, shareKey?: string | null) =>
			[...libraryQueryKeys.myCard.byId(cardId), shareKey ?? null] as const,
	},
	myCardLibrary: {
		all: ["myCardLibrary"] as const,
		list: (limit: number) =>
			[...libraryQueryKeys.myCardLibrary.all, limit] as const,
	},
};
